import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api/config/';

class ConfigService {
    getMailConfig() {
        return axioscommon.get(API_URL + 'mail', { headers: authHeader() });
    }
    getLocalConfig() {
        return axioscommon.get(API_URL + 'localizations', { headers: authHeader() });
    }
    getTicketConfig() {
        return axioscommon.get(API_URL + 'ticket', { headers: authHeader() });
    }
    getLicenseInfo() {
        return axioscommon.get(API_URL + 'license', { headers: authHeader() });
    }
    setMailConfig(data) {
        return axioscommon.post(API_URL + 'setmail', data, { headers: authHeader() });
    }
    setLocalConfig(data) {
        return axioscommon.post(API_URL + 'setlocal', data, { headers: authHeader() });
    }
    clearCache() {
        return axioscommon.get(API_URL + 'clearcache', { headers: authHeader() });
    }
    rebootServer() {
        return axioscommon.get(API_URL + 'reboot', { headers: authHeader() });
    }
    getLogs() {
        return axioscommon.get(API_URL, { headers: authHeader() });
    }
}

export default new ConfigService();
